<template>
    <table-base :filter="filter" :headers="headers" :api-data="apiData" :sorting="sorting" :items-field="itemsField" :edit-page-name="editPageName" :api-method="apiMethod" :claim-name="claimName" :form-title="formTitle" :excel-title="excelTitle" :has-edit-page="hasEditPage" :table-form="siteFloralVarietyForm" :refresh-key="refreshKey" :show-expand="false" :has-import="true" />
</template>

<script>
    export default {
        props: [
            'filter',
            'refreshKey'
        ],
        components: {
            tableBase: () => import('../components/TableBase'),
        },
        data() {
            return {
                siteFloralVarietyForm: () => import('../forms/SiteFloralVarietyForm'),
                headers: [
                    { text: 'Site', value: 'siteId', table: 'sites', form: () => import('../forms/SiteForm') },
                    { text: 'Floral Variety', value: 'floralVarietyId', table: 'floralVarieties', form: () => import('../forms/FloralVarietyForm') },
                    { text: 'On', value: 'on', format: this.formatDate },
                    { text: 'Is Dominant', value: 'isDominant' },
                    { text: '', value: 'action' }
                ],
                apiData: {
                    floralVarieties: [],
                    sites: [],
                    items: []
                },
                sorting: [
                    { column: "on", direction: "descending" },
                    { column: "siteId", direction: "ascending" },
                    { column: "floralVarietyId", direction: "ascending" },
                ],
                itemsField: 'siteFloralVarieties',
                editPageName: 'siteFloralVariety',
                apiMethod: 'SiteFloralVarieties',
                claimName: 'SiteFloralVarieties',
                formTitle: 'Site Floral Variety',
                excelTitle: 'Site Floral Varieties',
                hasEditPage: false,
            }
        },
    };
</script>
